import { render, staticRenderFns } from "./CoordinationConversionAttributeSettingsCreate.vue?vue&type=template&id=a08639a0&scoped=true"
import script from "./CoordinationConversionAttributeSettingsCreate.vue?vue&type=script&lang=ts"
export * from "./CoordinationConversionAttributeSettingsCreate.vue?vue&type=script&lang=ts"
import style0 from "./CoordinationConversionAttributeSettingsCreate.vue?vue&type=style&index=0&id=a08639a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08639a0",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/coordination/conversion-attribute/coordination-conversion-attribute-settings-create.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2Fclient-settings%2Fcoordination%2Fconversion-attribute%2FCoordinationConversionAttributeSettingsCreate.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports